import {
  MAP_SELECTION_APPLY,
  SINGLE_CLICK_SELECTION_APPLY,
  EXTENT_SELECTION_APPLY,
  // EDIT_SESSION_COPY_FROM_LAYER,
  SELECT_MODE_TOGGLE,
  MAP_SELECTION_CLEAR,
  EXTENT_SELECTION_START,
  TOGGLE_GET_FEATURE_INFO,
  WMS_GET_FEATURE_INFO,
  SET_GET_FEATURE_INFO_LAYER,
  CANCEL_GET_FEATURE_INFO,
  TOGGLE_ACTIVE_LAYER,
  TOGGLE_REPORT_DEMAND,
  TOGGLE_OBJECT_DETAILS_STATE

  // EDIT_SESSION_CHECK_IF_EDITED_BY_OTHER_USER
} from './actions.type';

import {
  SELECT_FEATURE_POPUP_HIDE,
  SELECT_FEATURE_POPUP_SHOW,
  SELECT_CONTROL_SET,
  SELECT_MODE_SET,
  SELECT_MULTIPLE_ACTIVATE,
  WINDOW_NOTIFICATION_SHOW,
  REMOVE_DRAW_INTERACTION,
  MEASUREMENTS_ENABLED_SET,
  FEATURES_PREPEND_FROM_SELECTION,
  FEATURES_SET,
  SELECT_DRAWN_FEATURE_SET, SELECT_FEATURE_DROPDOWN_HIDE, SELECT_FEATURE_DROPDOWN_SHOW, SELECT_FEATURE_FROM_DROPDOWN,
  SET_AUTH_CONTEXT
} from './mutations.type';

import { Vector as VectorLayer } from 'ol/layer';
import { Vector as VectorSource } from 'ol/source';
import { createBox } from 'ol/interaction/Draw';
import { Style, Stroke, Fill } from 'ol/style';
import { Draw } from 'ol/interaction';
import TileWMSSource from 'ol/source/TileWMS';
import Point from 'ol/geom/Point';
import Polygon from 'ol/geom/Polygon';
import LineString from 'ol/geom/LineString';
import * as olProj from 'ol/proj';

import { Api as ApiWarstwyWektorowe } from '../api/api-warstwy-wektorowe';
import { Api as LayersApi } from '../api/api-warstwy';
import { Api as ApiUslugiMapowe } from '../api/api-uslugi-mapowe';
import MapLayerStyleBuilder from '../models/MapLayerStyleBuilder';
import {
  MODE_POINT,
  MODE_POLYGON,
  MODE_RECTANGLE,
  MODE_NONE
} from '../common/selectModes';
import { LayerTypes } from '../common/layerEnums';
import { MultiPolygon } from 'ol/geom';
import { changeFeaturePropertiesNames } from '../api/HelperFunctions';
import MapLayerBuilder from '../models/MapLayerBuilder';
import uniqBy from "lodash/uniqBy";
import layers from "../components/Layers.vue";
import layer from "../components/Layer.vue";

const settings = require('../api/SettingsInstance');

const initialState = {
  mode: MODE_POINT,
  pointModeMultiple: false,
  featurePopupPosition: undefined,
  multipleFeaturePopupPosition: undefined,
  featurePopupLayer: null,
  featurePopupHeader: null,
  featurePopupAttributes: [],
  control: null,
  selectedFeatures: new Set(),
  selectedObjects: [],
  drawLayer: null,
  drawInteraction: null,
  layersWithAllFeaturesSelected: new Set(),
  featurePopupHtml: null,
  getFeatureInfoEnabled: false,
  getReportingDemandEnabled: false,
  toggleObjectDetailsState: false,
  gettingFeatureInfo: false,
  getFeatureInfoSelectedLayer: null,
  getFeatureInfoLayer: null,
  featuresData: null,
  selectModeDrawnedFeature: null,
  featureDropdownPosition: undefined,
  multipleFeatureDropdownPosition: undefined,
  featureDropdownLayer: null,
  featuresList: [],
  userEmail: null,
  userOrgId: null,
};

let mapSelectionApplyInProgress = false;
let mapSelectionApplyQueue = [];

const state = Object.assign({}, initialState);
const rasterLayers = [LayerTypes.wms, LayerTypes.wmts, LayerTypes.wcs];
const keysToBeautify = [
  'inne_Z.3.II.2.1.1.4',
  'inne_Z.3.II.2.1.2.7',
  'inne_Z.3.II.2.2.1.4',
  'inne_Z.3.II.2.2.2.7',
  'inne_Z.3.II.3.1.2.2.7',
  'inne_Z.3.II.3.2.2.2.7',
  'inne_Z.3.II.4.3',
  'stawki_zroznicowane_Z.3.II.2.3',
  'stawki_zroznicowane_Z.3.II.3.4',
  'lista_zalacznikow'
];

const isJsonStringCorrect = function(str) {
  try {
    var json = JSON.parse(str);
    return typeof json === 'object';
  } catch (e) {
    return false;
  }
};

const beautifyProperties = function({
  key,
  value,
  dictionaries,
  featureTableMeta
}) {
  const activeLayerColumn = featureTableMeta.kolumny.find(kolumna => {
    return key == kolumna.nazwa;
  });
  let dictionary = null;

  if (activeLayerColumn === undefined) {
    return value;
  }

  switch (activeLayerColumn.slownik) {
    case '0':
      break;
    case '1':
      if (value) {
        dictionary = dictionaries.find(dictionary => {
          return dictionary.nazwa == activeLayerColumn.nazwa_slownika;
        });
        const field = dictionary.pola.find(dictionaryFielf => {
          return dictionaryFielf.value == value;
        });
        value = field ? (field.hint || field.value) : value;
      }
      break;
    case '2':
      if (value && value != '') {
        dictionary = dictionaries.find(dictionary => {
          return dictionary.nazwa == activeLayerColumn.nazwa_slownika;
        });
        let arrayOfFields = [];
        arrayOfFields = value.split(';').map(val => {
          return (
            dictionary.pola.find(dictionaryFielf => {
              return dictionaryFielf.value == val;
            }) || []
          );
        });
        let arrayOfValues = [];
        arrayOfValues = arrayOfFields.map(field => {
          return field.hint || field.value;
        });
        value = arrayOfValues.join(', ');
      }
      break;
    case '3':
      value ? (value = 'Tak') : (value = 'Nie');
      break;
  }

  return value;
};

const actions = {
  async [MAP_SELECTION_APPLY](context, payload) {
    payload = payload || {};

    if (
      payload.control &&
      context.state.control &&
      context.state.control > payload.control
    ) {
      return;
    }

    if (mapSelectionApplyInProgress) {
      mapSelectionApplyQueue.push(payload);
      return;
    }

    mapSelectionApplyInProgress = true;

    let selectedFeatureObjs = [];

    if (context.rootGetters.dataFeedId) {
      let dataFeedFeatureSet = new Set(
        (context.rootGetters.features || []).map(x => x.id)
      );

      selectedFeatureObjs = (payload.selectedFeatureObjs || []).filter(x =>
        dataFeedFeatureSet.has(x.id || x.getId())
      );
    } else {
      selectedFeatureObjs = payload.selectedFeatureObjs || [];
    }

    let append = payload.append;
    let activeLayer = context.rootGetters.featuresLayer;
    let deselect = payload.deselect;

    let selectedIds = [];

    if (activeLayer) {
      let currentSelected = context.rootGetters.selectedFeatures || [];

      if (deselect) {
        selectedFeatureObjs = currentSelected.filter(
          x => !selectedFeatureObjs.find(y => y.id === x.id)
        );
      } else if (append) {
        selectedFeatureObjs = currentSelected.concat(selectedFeatureObjs);
      }

      selectedIds = selectedFeatureObjs.map(x => {
        return x.id || x.getId();
      });

      if (context.rootGetters.editSession) {
        // await context.dispatch(
        //   EDIT_SESSION_COPY_FROM_LAYER,
        //   selectedFeatureObjs
        // );
        // context.dispatch(EDIT_SESSION_CHECK_IF_EDITED_BY_OTHER_USER, {
        //   featureIds: selectedIds
        // });
      } else {
        context.commit(FEATURES_PREPEND_FROM_SELECTION, selectedFeatureObjs);
      }
    }

    context.commit('applySelectionForLayer', selectedIds);
    context.commit('applySelectionObjectsForLayer', selectedFeatureObjs);

    let features = context.rootGetters.features.filter(
      x => !x.loadedFromMap || context.getters.selectedMapFeatures.has(x.id)
    );
    context.commit(FEATURES_SET, features);

    if (activeLayer) {
      const apiStyle = context.rootGetters.styleForLayer(activeLayer.styleId);
      const style = new MapLayerStyleBuilder(apiStyle, activeLayer).getStyle();
      if (
        activeLayer.mapHistoricalLayer &&
        activeLayer.mapHistoricalLayer.setStyle &&
        activeLayer.mapHistoricalLayer.getVisible()
      ) {
        activeLayer.mapHistoricalLayer.setStyle(style);
      } else if (
        activeLayer.mapLayer &&
        activeLayer.mapLayer.setStyle &&
        activeLayer.mapLayer.getVisible()
      ) {
        activeLayer.mapLayer.setStyle(style);
        new MapLayerBuilder(activeLayer, style).updateOlLayer();
        activeLayer.mapLayer.getSource().clear();
      }
    }

    mapSelectionApplyInProgress = false;

    if (mapSelectionApplyQueue.length > 0) {
      context.dispatch(MAP_SELECTION_APPLY, mapSelectionApplyQueue.shift());
    }
  },
  async [WMS_GET_FEATURE_INFO](context, payload) {
    context.commit(SELECT_FEATURE_DROPDOWN_HIDE);

    const colidingToolEnabled =
      context.rootGetters.measurementsEnabled ||
      context.rootGetters.roadLaneAnalysisStarted ||
      context.rootGetters.poleAnalysisReady ||
      context.rootGetters.connectionAnalysisLaunched ||
      context.rootGetters.editSession;

    if (!state.getFeatureInfoEnabled || colidingToolEnabled) return;
    var control = Date.now();
    context.commit(SELECT_CONTROL_SET, control);

    let v_layers = payload.map.getLayers();
    let v_sel_layers_gfi = 0;
    v_layers.forEach(function(v_layer) {
      if (v_layer.getVisible()) {
        let source = v_layer.getSource();
        let vk_url =
          source.urls != undefined && source.urls.length > 0
            ? source.urls[0]
            : '';

        if (
          typeof source.format_ == 'string' &&
          source.format_ != undefined &&
          source.format_.includes('image/') &&
          source.matrixSet_ != undefined &&
          source.urls.length > 0 &&
          vk_url &&
          vk_url.includes('geoserver') &&
          (vk_url.includes('pit') || source.layer_.includes('pit'))
        ) {
          v_sel_layers_gfi++;
        }
      }
    });
    try {
      context.commit('toggleGettingFeatureInfo');
      const api = new ApiUslugiMapowe();

      if (context.rootGetters.layers.find(x => x.active)) {
        await context.dispatch(SINGLE_CLICK_SELECTION_APPLY, {
          map: payload.map,
          event: payload.event,
          self: payload.self
        });
      } else if (v_sel_layers_gfi > 0) {
        let v_layers = payload.map.getLayers();
        var v_url = new Array();
        var v_last_layer = null;
        v_layers.forEach(function(v_layer) {
          if (v_layer.getVisible()) {
            let source = v_layer.getSource();
            let vk_url = source.urls.length > 0 ? source.urls[0] : '';
            if (
              source.format_ &&
              source.format_.includes('image/') &&
              source.matrixSet_ != undefined &&
              source.urls.length > 0 &&
              vk_url &&
              vk_url.includes('geoserver') &&
              (vk_url.includes('pit') || source.layer_.includes('pit'))
            ) {
              v_last_layer = v_layer;
              let grid = source.getTileGrid();
              let obj = {};

              obj.pixel = payload.event.pixel;
              obj.coordinate = payload.event.coordinate;
              obj.zoom = payload.map.getView().getZoom();
              let c_dest = olProj.transform(
                payload.event.coordinate,
                'EPSG:2180',
                'EPSG:3857'
              );
              obj.cc_dest = c_dest;
              obj.c_dest = payload.event.coordinate;
              obj.tileCord_cc = grid.getTileCoordForCoordAndZ(
                obj.c_dest /*payload.event.coordinate*/,
                grid.getZForResolution(payload.map.getView().getResolution(), 1)
              );
              obj.tileCord = grid.getTileCoordForCoordAndZ(
                obj.cc_dest,
                grid.getZForResolution(payload.map.getView().getResolution(), 1)
              );
              obj.tileCord[2]++;
              obj.z = grid.getZForResolution(
                payload.map.getView().getResolution()
              );
              obj.zoom = payload.map.getView().getZoom();
              obj.style = source.getStyle();
              obj.proj = source.getProjection();
              obj.matrix = source.getMatrixSet();
              obj.tileCoords = grid.getTileCoordExtent(obj.tileCord);
              obj.tmpSize = source.tmpSize;

              obj.i =
                Math.abs(
                  Math.floor(
                    ((obj.cc_dest[0] - obj.tileCoords[0]) /
                      (obj.tileCoords[2] - obj.tileCoords[0])) *
                      source.tmpSize[0]
                  )
                ) % source.tmpSize[0];
              obj.j =
                Math.abs(
                  Math.floor(
                    source.tmpSize[0] -
                      ((obj.cc_dest[1] - obj.tileCoords[1]) /
                        (obj.tileCoords[3] - obj.tileCoords[1])) *
                        source.tmpSize[0]
                  )
                ) % source.tmpSize[0];
              let url =
                vk_url +
                (vk_url.includes('?') ? '&' : '?') +
                'REQUEST=GetFeatureInfo&QUERY_LAYER=' +
                source.layer_ +
                '&LAYER=' +
                source.layer_ +
                '&STYLE=' +
                obj.style +
                '&TileMatrixSet=' +
                obj.matrix +
                '&TileMatrix=' +
                obj.matrix +
                ':' +
                Math.abs(obj.tileCord[0]) +
                '&TileRow=' +
                Math.abs(obj.tileCord[2]) +
                '&TileCol=' +
                Math.abs(obj.tileCord[1]) +
                '&J=' +
                obj.j +
                '&I=' +
                obj.i +
                '&format=text/html&INFOFORMAT=text/html&content_type=text/html';
              v_url.push(url);
            }
          }
        });
        if (v_url.length > 0) {
          let v_html = '';
          for (let li = 0; li < v_url.length; li++) {
            v_html +=
              (li > 0 ? '<br/>' : '') +
              '<iframe src="' +
              v_url[li] +
              '" border="0" style="width: 94%;max-height: 260px;height: 160px;border: 0px"></iframe>';
          }
          context.commit(SELECT_FEATURE_POPUP_SHOW, {
            position: payload.event.coordinate,
            layer: null /*v_last_layer*/,
            html: v_html,
            header: 'Informacje o obiektach',
            self: payload.self
          });
        }
      } else if (state.getFeatureInfoSelectedLayer) {
        const selectedLayerNames = state.getFeatureInfoSelectedLayer.names;
        if (
          selectedLayerNames &&
          (selectedLayerNames.includes('pit:nadlesnictwa') ||
            selectedLayerNames.includes('pit:rejestr_nieruchomosci') ||
            selectedLayerNames.includes('pit:drogi_stawki_jst') ||
            selectedLayerNames.includes('pit:drogi_stawki') ||
            selectedLayerNames.includes('pit:decyzja'))
        ) {
          await context.dispatch(SINGLE_CLICK_SELECTION_APPLY, {
            map: payload.map,
            event: payload.event,
            self: payload.self
          });
        } else {
          const url = state.getFeatureInfoLayer.mapLayer
            .getSource()
            .getGetFeatureInfoUrl(
              payload.event.coordinate,
              context.rootGetters.resolution,
              context.getters.coordinateSystem,
              { INFO_FORMAT: 'text/html' }
            );
          const wfsProxyResponse = await api.getWfsProxy({
            wso2_id: this.contextEmail ? this.contextEmail : null,
            orgid: this.contextOrganizationId
              ? this.contextOrganizationId
              : null,
            url: url
          });
          context.commit(SELECT_FEATURE_POPUP_SHOW, {
            position: payload.event.coordinate,
            layer: state.getFeatureInfoLayer,
            html: wfsProxyResponse.body,
            header: `${state.getFeatureInfoLayer.title} - GetFeatureInfo`,
            self: payload.self
          });
        }
      } else {
        const systemFeatureSearchResult = await findFeatureForSingleClickSelection(
          context,
          payload
        );
        if (systemFeatureSearchResult.manyLayersFound) {
          context.commit(WINDOW_NOTIFICATION_SHOW, {
            type: 'warn',
            title: 'Uwaga. Znaleziono obiekty z różnych warstw.',
            message:
              'Aby wybrać obiekt z konkretnej warstwy należy ją aktywować.',
            duration: 30000,
            changedDuration: 30000
          });
        } else if (systemFeatureSearchResult.selectionError) {
          context.commit(WINDOW_NOTIFICATION_SHOW, {
            type: 'error',
            title: 'Uwaga. Błąd selekcji.',
            message: 'Selekcja obiektów nie powiodła się.1',
            duration: 5000
          });
        } else {
          const visibleFeatureInfoEnabledLayers = context.rootGetters.layers.filter(
            l =>
              !l.isSystem &&
              l.mapLayer &&
              l.mapLayer.getVisible() &&
              l.mapLayer.getSource() &&
              l.mapLayer.getSource().getGetFeatureInfoUrl
          );
          const wfsProxyQueries = [];
          visibleFeatureInfoEnabledLayers.forEach(foundLayer => {
            const url = foundLayer.mapLayer
              .getSource()
              .getGetFeatureInfoUrl(
                payload.event.coordinate,
                context.rootGetters.resolution,
                context.getters.coordinateSystem,
                { INFO_FORMAT: 'application/json' }
              );
            wfsProxyQueries.push(
              new Promise(resolve => {
                api
                  .getWfsProxy({
                    wso2_id: this.contextEmail ? this.contextEmail : null,
                    orgid: this.contextOrganizationId
                      ? this.contextOrganizationId
                      : null,
                    url: url
                  })
                  .then(response =>
                    resolve({ success: true, response, layer: foundLayer })
                  )
                  .catch(_ => resolve({ success: false, layer: foundLayer }));
              })
            );
          });

          try {
            var wfsProxyResponses = await Promise.all(wfsProxyQueries);
          } catch (e) {
            console.log('błąd');
          }

          const responsesWithFeatures = wfsProxyResponses.filter(
            resp =>
              resp.success &&
              resp.response.body &&
              Array.isArray(resp.response.body.features) &&
              resp.response.body.features.length > 0
          );

          if (
            responsesWithFeatures.length > 1 ||
            (responsesWithFeatures.length == 1 &&
              systemFeatureSearchResult.featuresFound)
          ) {
            context.commit(WINDOW_NOTIFICATION_SHOW, {
              type: 'warn',
              title: 'Uwaga. Znaleziono obiekty z różnych warstw.',
              message:
                'Aby wybrać obiekt z konkretnej warstwy należy ją aktywować.',
              duration: 30000,
              changedDuration: 30000
            });
          } else if (responsesWithFeatures.length == 1) {
            const url = responsesWithFeatures[0].layer.mapLayer
              .getSource()
              .getGetFeatureInfoUrl(
                payload.event.coordinate,
                context.rootGetters.resolution,
                context.getters.coordinateSystem,
                { INFO_FORMAT: 'text/html' }
              );
            const wfsProxyResponse = await api.getWfsProxy({
              wso2_id: this.contextEmail ? this.contextEmail : null,
              orgid: this.contextOrganizationId
                ? this.contextOrganizationId
                : null,
              url: url
            });
            context.commit(SELECT_FEATURE_POPUP_SHOW, {
              position: payload.event.coordinate,
              layer: responsesWithFeatures[0].layer,
              html: wfsProxyResponse.body,
              header: `${responsesWithFeatures[0].layer.title} - GetFeatureInfo`,
              self: payload.self
            });
          } else if (systemFeatureSearchResult.featuresFound) {
            if (systemFeatureSearchResult.selectedFeatureLayer.isSystem) {
              context.dispatch(TOGGLE_ACTIVE_LAYER, {
                layer: systemFeatureSearchResult.selectedFeatureLayer,
                dontToggleIfActive: true
              });
            }

            context.dispatch('applyPointSelection', {
              selectedFeature: systemFeatureSearchResult.selectedFeature,
              selectedFeatureLayer:
                systemFeatureSearchResult.selectedFeatureLayer,
              event: payload.event,
              control: control
            });

            context.commit(WINDOW_NOTIFICATION_SHOW, {
              type: 'info',
              title:
                'Informacja. Odczytywanie informacji obiektów innych warstw.',
              message:
                'W celu odczytania informacji o innych obiektach należy wybrać inną warstwę aktywną lub warstwę odczytu informacji (ikona "i" na prawo od nazwy warstwy).',
              duration: 10000,
              changedDuration: 10000
            });
          }

          const unsuccessfulResponses = wfsProxyResponses.filter(
            resp => !resp.success
          );
          if (unsuccessfulResponses.length > 0) {
            const layerNames = unsuccessfulResponses
              .map(resp => resp.layer.title)
              .join(', ');
            setTimeout(
              () =>
                context.commit(WINDOW_NOTIFICATION_SHOW, {
                  type: 'error',
                  title: 'Uwaga. Brak odpowiedzi z niektórych warstw.',
                  message: `Zapytanie o obiekty warstw(y): ${layerNames} zakończyło się niepowodzeniem.`,
                  duration: 10000,
                  changedDuration: 10000
                }),
              200
            );
          }

          const responsesOtherThanJson = wfsProxyResponses.filter(
            resp =>
              resp.success &&
              resp.layer &&
              resp.response.response.headers['content-type'] &&
              !resp.response.response.headers['content-type'].includes(
                'application/json'
              )
          );
          if (responsesOtherThanJson.length > 0) {
            const layerNames = responsesOtherThanJson
              .map(resp => resp.layer.title)
              .join(', ');
            setTimeout(
              () =>
                context.commit(WINDOW_NOTIFICATION_SHOW, {
                  type: 'warn',
                  title:
                    'Uwaga. Brak kompletnej odpowiedzi z niektórych warstw.',
                  message: `Warstwy: ${layerNames} nie obsługują wymaganego rodzaju odpowedzi. Aktywuj lub włącz odczytywanie informacji konkretnej warstwy aby pobrać pełną odpowiedź.`,
                  duration: 10000,
                  changedDuration: 10000
                }),
              200
            );
          }
        }
      }
    } catch (exception) {
      setTimeout(
        () =>
          context.commit(WINDOW_NOTIFICATION_SHOW, {
            type: 'error',
            title: 'Uwaga. Błąd pobierania danych.',
            message: 'Pobranie danych obiektu nie powiodło się.',
            duration: 5000
          }),
        200
      );
    } finally {
      context.commit('toggleGettingFeatureInfo');
    }
  },
  async [SINGLE_CLICK_SELECTION_APPLY](context, payload) {
    const colidingToolEnabled =
      context.rootGetters.measurementsEnabled ||
      context.rootGetters.roadLaneAnalysisStarted ||
      context.rootGetters.poleAnalysisReady ||
      context.rootGetters.connectionAnalysisLaunched;

    if (colidingToolEnabled) return;
    var control = Date.now();
    context.commit(SELECT_CONTROL_SET, control);

    const showNotifications = !context.rootGetters.editSession;

    const featureSearchResult = await findFeatureForSingleClickSelection(
      context,
      payload
    );
    if (featureSearchResult.manyLayersFound && showNotifications) {
      context.commit(WINDOW_NOTIFICATION_SHOW, {
        type: 'warn',
        title: 'Uwaga. Znaleziono obiekty z różnych warstw.',
        message: 'Aby wybrać obiekt z konkretnej warstwy należy ją aktywować.',
        duration: 30000,
        changedDuration: 30000
      });
    } else if (featureSearchResult.selectionError) {
      context.commit(WINDOW_NOTIFICATION_SHOW, {
        type: 'error',
        title: 'Uwaga. Błąd selekcji.',
        message: 'Selekcja obiektów nie powiodła się.2',
        duration: 5000
      });
    } else if (featureSearchResult.featuresFound) {
      if (featureSearchResult.onEditSessionMapLayer) {
        let editedLayer = context.rootGetters.layers.find(
          x => x.id == context.rootGetters.editSessionLayerId
        );

        if (featureSearchResult.selectedFeatures.length === 1) {
          context.dispatch('applyPointSelection', {
            selectedFeature: featureSearchResult.selectedFeatures[0],
            selectedFeatureLayer: editedLayer,
            event: payload.event,
            control: control,
            self: payload.self
          });
      } else if (featureSearchResult.selectedFeatures.length > 1) {
          context.dispatch('showPointSelectionDropdown', {
            features: featureSearchResult.selectedFeatures,
            selectedFeature: featureSearchResult.selectedFeatures[0],
            selectedFeatureLayer: editedLayer,
            event: payload.event,
            control: control,
            self: payload.self
          })
        }

      } else {

        if (featureSearchResult.selectedFeatures.length === 1) {

          if (featureSearchResult.selectedFeatureLayer.isSystem) {
            context.dispatch(TOGGLE_ACTIVE_LAYER, {
              layer: featureSearchResult.selectedFeatureLayer,
              dontToggleIfActive: true
            });
          }

          context.dispatch('applyPointSelection', {
            selectedFeature: featureSearchResult.selectedFeatures[0],
            selectedFeatureLayer: featureSearchResult.selectedFeatureLayer,
            event: payload.event,
            control: control,
            self: payload.self
          });
          if (
            showNotifications &&
            !featureSearchResult.selectedFeatureLayer.active
          ) {
            context.commit(WINDOW_NOTIFICATION_SHOW, {
              type: 'info',
              title:
                'Informacja. Odczytywanie informacji obiektów innych warstw.',
              message:
                'W celu odczytania informacji o innych obiektach należy wybrać inną warstwę aktywną lub warstwę odczytu informacji (ikona "i" na prawo od nazwy warstwy).',
              duration: 30000,
              changedDuration: 30000
            });
          }

        } else if (featureSearchResult.selectedFeatures.length > 1) {
          context.dispatch('showPointSelectionDropdown', {
            features: featureSearchResult.selectedFeatures,
            selectedFeature: featureSearchResult.selectedFeatures[0],
            event: payload.event,
            control: control,
            self: payload.self
          })

        }
      }
    } else {
      var nonActiveVectorLayers = context.rootGetters.layers.filter(
        x =>
          !x.active &&
          x.isSystem &&
          x.visible &&
          rasterLayers.indexOf(x.type) < 0
      );
      const featureSearchResultOnNonActive = await findFeatureForSingleClickSelection(
        context,
        payload,
        nonActiveVectorLayers
      );

      if (featureSearchResultOnNonActive.featuresFound) {
        context.commit(WINDOW_NOTIFICATION_SHOW, {
          type: 'warn',
          title: `Uwaga. Znaleziono obiekt na warstwie <span class="font-weight-bold">${(
            featureSearchResultOnNonActive.selectedFeatureLayer || {}
          ).title || '(brak nazwy)'}</span>.`,
          message: 'Aby wybrać obiekt z tej warstwy należy ją aktywować.',
          duration: 5000,
          changedDuration: 5000
        });
      } else if (featureSearchResultOnNonActive.manyLayersFound) {
        context.commit(WINDOW_NOTIFICATION_SHOW, {
          type: 'warn',
          title: 'Uwaga. Znaleziono obiekty na nieaktywnych warstwach.',
          message:
            'Aby wybrać obiekt z konkretnej warstwy należy ją aktywować.',
          duration: 30000,
          changedDuration: 30000
        });
      } else {
        context.dispatch('applyPointSelection', {
          selectedFeature: null,
          selectedFeatureLayer: featureSearchResult.selectedFeatureLayer,
          event: payload.event,
          control: control,
          self: payload.self
        });
      }
    }
  },
  async [EXTENT_SELECTION_APPLY](context, payload) {
    var control = Date.now();
    context.commit(SELECT_CONTROL_SET, control);

    context.commit(SELECT_FEATURE_POPUP_HIDE);

    var api = new ApiWarstwyWektorowe();

    let layer = context.rootGetters.featuresLayer;

    let selectionGeometry = payload.event.feature.getGeometry();

    if (layer && layer.visible) {
      let body = {
        analiza_filter: {
          geometry_geojson: {
            coordinates: selectionGeometry.getCoordinates(),
            type: 'Polygon'
          },
          typ_wejsciowych: 'geometry_geojson',
          typ_analizy: 'zawieraja'
        }
      };
      api
        .postWarstwyWektoroweByIdObiektySelekcja({
          wso2_id: this.contextEmail ? this.contextEmail : null,
          orgid: this.contextOrganizationId ? this.contextOrganizationId : null,
          id: layer.id,
          body: body
        })
        .then(async function(response) {
          if (control === context.state.control) {
            if (
              context.getters.isSelectModePolygon ||
              context.getters.isSelectModeRectangle
            ) {
              let selectedObjs = response.body.features;

              if (context.getters.editSession) {
                let vectorSource = context.rootGetters.editSessionMapLayer.getSource();
                selectedObjs = selectedObjs.filter(
                  x => !vectorSource.getFeatureById(x.id)
                );

                vectorSource.forEachFeature(function(feature) {
                  let coords = feature.getGeometry().getCoordinates();

                  if (feature.getGeometry().getType() === 'Point') {
                    if (selectionGeometry.intersectsCoordinate(coords)) {
                      selectedObjs.push(feature);
                    }
                  } else {
                    if (feature.getGeometry().getType() === 'Polygon') {
                      coords = coords[0];
                    }
                    let isInsideSelectionGeometry = true;
                    coords.forEach(coord => {
                      isInsideSelectionGeometry &= selectionGeometry.intersectsCoordinate(
                        coord
                      );
                    });

                    if (isInsideSelectionGeometry) {
                      selectedObjs.push(feature);
                    }
                  }
                });
              }
              context.dispatch(MAP_SELECTION_APPLY, {
                selectedFeatureObjs: selectedObjs,
                control: control
              });
            }
          }
        })
        .catch(function(error) {
          context.commit(WINDOW_NOTIFICATION_SHOW, {
            type: 'error',
            title: 'Uwaga. Błąd selekcji.',
            message: 'Selekcja obiektów nie powiodła się.3',
            duration: 5000
          });
        })
        .finally(function() {
          payload.drawLayerSource.clear();
        });
    }
  },
  [SELECT_MODE_TOGGLE](context, payload) {
    context.dispatch(CANCEL_GET_FEATURE_INFO);

    if (!context.getters.isSelectModeNone) {
      context.dispatch(MAP_SELECTION_CLEAR);

      if (context.state.drawLayer) {
        if (payload.map) {
          payload.map.removeLayer(context.state.drawLayer);
        }
      }

      if (context.state.drawInteraction) {
        if (payload.map) {
          payload.map.removeInteraction(context.state.drawInteraction);
        }
      }
    }

    if (
      (payload.mode === MODE_POLYGON || payload.mode === MODE_RECTANGLE) &&
      !context.rootGetters.featuresLayer
    ) {
      context.commit(SELECT_MODE_SET, MODE_NONE);
      context.commit(WINDOW_NOTIFICATION_SHOW, {
        type: 'warn',
        title: 'Uwaga. Nie wybrano warstwy aktywnej.',
        message:
          'Aby uruchomić tryb selekcji elementów należy wybrać warstwę aktywną.',
        duration: 30000,
        changedDuration: 30000
      });
    } else {
      context.commit(SELECT_MODE_SET, payload.mode);

      if (
        context.getters.isSelectModePolygon ||
        context.getters.isSelectModeRectangle
      ) {
        if (context.rootGetters.featuresLayer) {
          context.dispatch(EXTENT_SELECTION_START, {
            map: payload.map
          });
        }
      }
    }
  },
  [MAP_SELECTION_CLEAR](context) {
    context.commit(SELECT_FEATURE_POPUP_HIDE);
    context.dispatch(MAP_SELECTION_APPLY);
  },
  [EXTENT_SELECTION_START](context, payload) {
    let fillColor = 'rgba(255, 255, 255, 0.3)';
    let strokeColor = 'rgba(239, 212, 38, 1)';

    let drawLayerSource = new VectorSource({
      useSpatialIndex: false
    });

    let drawLayer = new VectorLayer({
      source: drawLayerSource,
      zIndex: 100,
      style: new Style({
        fill: new Fill({
          color: fillColor
        }),
        stroke: new Stroke({
          color: strokeColor,
          width: 1
        })
      })
    });

    context.commit('setDrawLayer', drawLayer);

    let drawStyle = new Style({
      fill: new Fill({
        color: fillColor
      }),
      stroke: new Stroke({
        color: strokeColor,
        width: 3
      })
    });

    var drawInteraction;

    if (context.getters.isSelectModeRectangle) {
      drawInteraction = new Draw({
        source: drawLayerSource,
        type: 'Circle',
        style: drawStyle,
        geometryFunction: createBox()
      });
    }
    if (context.getters.isSelectModePolygon) {
      drawInteraction = new Draw({
        source: drawLayerSource,
        type: 'Polygon',
        style: drawStyle
      });
    }

    context.commit('setDrawInteraction', drawInteraction);

    payload.map.addLayer(drawLayer);
    payload.map.addInteraction(drawInteraction);

    drawInteraction.on(
      'drawstart',
      function(event) {
        drawLayerSource.clear();
      },
      this
    );

    drawInteraction.on('drawend', function(event) {
      context.commit(SELECT_DRAWN_FEATURE_SET, event.feature);

      // context.dispatch(EXTENT_SELECTION_APPLY, {
      //   event: event,
      //   drawLayerSource: drawLayerSource
      // });
    });
  },
  async getFeatureAttributes(context, payload) {
    const layer = context.rootGetters.layers.find(layer => {
      return layer.datasource === payload.feature.properties.layer;
    });
    try {
      const layersApi = new LayersApi();
      const response = await layersApi.getFeatureAttributesById({
        wso2_id: payload.self.contextEmail || null,
        orgid: payload.self.contextOrganizationId || null,
        layerId: layer.parentId || layer.id,
        obiektId: payload.feature.properties.element_uuid
      });
      if (response) {
        return response.body.atrybuty || {};
      } else {
        return {};
      }
    } catch (error) {
      if (error && error.response.includes('Brak uprawnień')) {
        context.commit(WINDOW_NOTIFICATION_SHOW, {
          type: 'warn',
          title: 'Uwaga. Brak uprawnień.',
          message:
            'Brak uprawnień do oczytywania atrybutów z wybranego obiektu.',
          duration: 8000
        });
      } else {
        context.commit(WINDOW_NOTIFICATION_SHOW, {
          type: 'error',
          title: 'Uwaga. Błąd przy odczytywaniu atrybutów.',
          message:
            'Odczytywanie atrybutów dla wybranego obiektu nie powiodło się.',
          duration: 8000
        });
      }

      return {};
    }

    return layerId;
  },
    async showPointSelectionDropdown(context, payload) {
    context.commit(SET_AUTH_CONTEXT, {
      self: payload.self
    })
    let selectedFeature = payload.selectedFeature;
    let selectedFeatures = payload.features;
    let selectedFeatureObjs = [];
    if (selectedFeature) {


      var popupPosition = undefined;

      selectedFeatureObjs = [getFeature(selectedFeature)];

      if (
        selectedFeatures.length > 1
      ) {

        if (selectedFeature.getFlatInteriorPoint) {
          popupPosition = selectedFeature.getFlatInteriorPoint();
        } else {
          popupPosition = payload.event.coordinate;
        }

        context.commit(SELECT_FEATURE_DROPDOWN_SHOW, {
          features: selectedFeatures,
          position: popupPosition,
        });
      } else {
        context.commit(SELECT_FEATURE_DROPDOWN_HIDE);
      }
    }

  },
  async applyPointSelection(context, payload) {
    let selectedFeatureLayer = payload.selectedFeatureLayer;
    let selectedFeature = payload.selectedFeature;
    let someFeatureSelected = selectedFeatureLayer && selectedFeature;
    let selectedFeatureObjs = [];
    if (someFeatureSelected) {
      if (
        context.rootGetters.editSession &&
        selectedFeatureLayer.id != context.rootGetters.editSessionLayerId
      ) {
        return;
      }

      var popupPosition = undefined;
      var popupHeader = null;
      var popupAttributes = [];
      var atrybutNazwa = selectedFeatureLayer.atrybutNazwa;

      selectedFeatureObjs = [getFeature(selectedFeature)];

      const featureAttributes = await context.dispatch('getFeatureAttributes', {
        feature: selectedFeature,
        self: payload.self
      });
      if (
        Object.keys(featureAttributes) &&
        Object.keys(featureAttributes).length
      ) {
        const layer = context.rootGetters.layers.find(layer => {
          return layer.datasource === selectedFeature.properties.layer;
        });

        const featureTableMeta = context.rootGetters.tableMeta.find(table => {
          return table.id === (layer.parentId || layer.id);
        });

        selectedFeature.properties =
          { ...selectedFeature.properties, ...featureAttributes } || {};

        //Get coordinates and flat them
        if (selectedFeature.getFlatInteriorPoint) {
          popupPosition = selectedFeature.getFlatInteriorPoint();
        } else {
          popupPosition = payload.event.coordinate;
        }

        if (selectedFeatureLayer.attributes && state.getFeatureInfoEnabled) {
          popupAttributes = selectedFeatureLayer.attributes
            .filter(x => {
              return (
                x.visible &&
                Object.keys(selectedFeature.properties).some(key => {
                  return key == x.key;
                })
              );
            })
            .map(item => {
              return {
                key: item.name,
                val: beautifyProperties({
                  key: item.key,
                  value: selectedFeature.properties[item.key],
                  dictionaries: context.rootGetters.dictionaries,
                  featureTableMeta: featureTableMeta
                }),
                isLink: false
              };
            });
          context.commit(SELECT_FEATURE_POPUP_SHOW, {
            position: popupPosition,
            layer: selectedFeatureLayer,
            attributes: popupAttributes,
            header: popupHeader
          });
        }
      } else {
        context.commit(SELECT_FEATURE_POPUP_HIDE);
      }
    }

    context.dispatch(MAP_SELECTION_APPLY, {
      selectedFeatureObjs: selectedFeatureObjs,
      append: context.state.pointModeMultiple,
      control: payload.control
    });
  },

  [TOGGLE_REPORT_DEMAND]({ state, commit, dispatch }) {
    state.getReportingDemandEnabled = !state.getReportingDemandEnabled;
  },
  [TOGGLE_OBJECT_DETAILS_STATE]({ state, commit, dispatch }) {
    state.toggleObjectDetailsState = !state.toggleObjectDetailsState;
  },
  [TOGGLE_GET_FEATURE_INFO]({ state, commit, dispatch }) {
    if (!state.getFeatureInfoEnabled)
      dispatch(SELECT_MODE_TOGGLE, { mode: MODE_NONE });

    if (state.getFeatureInfoEnabled) {
      commit(MEASUREMENTS_ENABLED_SET, false);
    }
    state.getFeatureInfoEnabled = !state.getFeatureInfoEnabled;
    if (!state.getFeatureInfoEnabled)
      state.getFeatureInfoLayer = state.getFeatureInfoSelectedLayer = null;
    commit(SELECT_FEATURE_POPUP_HIDE);
  },
  [CANCEL_GET_FEATURE_INFO]({ state, commit }) {
    if (state.getFeatureInfoEnabled) {
      commit(SELECT_FEATURE_POPUP_HIDE);
      state.getFeatureInfoLayer = state.getFeatureInfoSelectedLayer = null;
      state.getFeatureInfoEnabled = false;
    }
  },
  [SET_GET_FEATURE_INFO_LAYER](
    { state, commit, dispatch, rootGetters },
    layer
  ) {
    if (rootGetters.layers.some(l => l.active)) {
      commit(WINDOW_NOTIFICATION_SHOW, {
        type: 'warn',
        title: 'Uwaga. Wybranie warstwy do odczytu nie powiodło się.',
        message:
          'Inna warstwa jest aktywna. Aby wybrać warstwę do odczytu należy dezaktywować wszystkie aktywne warstwy.',
        duration: 30000,
        changedDuration: 30000
      });
      return;
    }

    state.getFeatureInfoLayer = state.getFeatureInfoSelectedLayer = layer;
    if (!state.getFeatureInfoEnabled && state.getFeatureInfoLayer)
      dispatch(TOGGLE_GET_FEATURE_INFO);

    commit(SELECT_FEATURE_POPUP_HIDE);
  },
    async [SELECT_FEATURE_FROM_DROPDOWN](context, payload) {
    const {feature} = payload;
    const layerDatasource = feature.properties.layer;
    const selectedLayers = context.rootGetters.layers.filter(l => l.datasource === layerDatasource);
    let selectedLayer = null;
    let popupAttributes = null;
    let fetchedAttributes = null;
    if (selectedLayers.length === 1) {
      selectedLayer = selectedLayers[0];

      const layersApi = new LayersApi();
      const response = await layersApi.getFeatureAttributesById({
        wso2_id: context.rootGetters.userEmail,
        orgid: context.rootGetters.userOrgId,
        layerId: selectedLayer.parentId || selectedLayer.id,
        obiektId: feature.properties.element_uuid
      });
      if (response) {
        fetchedAttributes = response.body.atrybuty || {};
      }
      const featureTableMeta = context.rootGetters.tableMeta.find(table => {
          return table.id === (selectedLayer.parentId || selectedLayer.id);
        });

      popupAttributes = selectedLayer.attributes
        .filter(x => {
          return (
            x.visible &&
            Object.keys(fetchedAttributes).some(key => {
              return key == x.key;
            })
          );
        })
        .map(item => {

          return {
            key: item.name,
            val: beautifyProperties({
              key: item.key,
              value: fetchedAttributes[item.key],
              dictionaries: context.rootGetters.dictionaries,
              featureTableMeta: featureTableMeta
            }),
            isLink: false
          };
        });

      context.commit(SELECT_FEATURE_POPUP_SHOW, {
        position: context.state.featureDropdownPosition,
        layer: selectedLayer,
        attributes: popupAttributes
      });
    }
  },
};

const mutations = {
  [REMOVE_DRAW_INTERACTION](state, payload) {
    if (state.drawLayer) {
      payload.map.removeLayer(state.drawLayer);
    }
    if (state.drawInteraction) {
      payload.map.removeInteraction(state.drawInteraction);
    }
  },
  [SELECT_FEATURE_POPUP_HIDE](state) {
    state.featurePopupPosition = undefined;
    state.multipleFeaturePopupPosition = undefined;
    state.featurePopupLayer = null;
    state.featurePopupAttributes = [];
    state.featurePopupHeader = null;
    state.featurePopupHtml = null;
  },
  [SELECT_FEATURE_POPUP_SHOW](state, payload) {
    state.featurePopupPosition = payload.position;
    state.featurePopupLayer = payload.layer;
    state.featurePopupAttributes = payload.attributes;
    state.featurePopupHeader = payload.header;

    if (typeof payload.html === 'string') {
      payload.html = payload.html.replace(/font-size:.+;/, 'font-size: 16px;');
    }
    state.featurePopupHtml = payload.html;
  },
  [SELECT_FEATURE_DROPDOWN_HIDE](state) {
    state.featuresList = [];
    state.featureDropdownPosition = undefined;
    state.multipleFeatureDropdownPosition = undefined;
    state.featureDropdownLayer = null;
  },
  [SELECT_FEATURE_DROPDOWN_SHOW](state, payload) {
    state.featuresList = payload.features;
    state.featureDropdownPosition = payload.position;
  },
  [SET_AUTH_CONTEXT](state, payload) {
    state.userEmail = payload.self.contextEmail;
    state.userOrgId = payload.self.contextOrganizationId;
  },
  showPopupForMultipleFeaturesSelected(state, payload) {
    state.multipleFeaturePopupPosition = payload.position;
    state.featurePopupLayer = payload.layer;

    var sortedFeaturesData = [];

    var communeRouteCategory = [];
    var districtRouteCategory = [];
    var vivoideshipRouteCategory = [];
    var countryRouteCategory = [];

    var terytName = 'kod_terc_Z.3.I.2';
    var sortedLength = [7, 4, 2, 0];
    var categoryName = 'kategoria_drogi_Z.3.2.1';
    var sortedCategories = ['gminna', 'powiatowa', 'wojewodzka', 'krajowa'];

    payload.featuresData.forEach(x => {
      if (
        x.attributes.find(
          z => z.key == terytName && z.val.length == sortedLength[0]
        )
      ) {
        communeRouteCategory.push(x);
      }
      if (
        x.attributes.find(
          z => z.key == terytName && z.val.length == sortedLength[1]
        )
      ) {
        districtRouteCategory.push(x);
      }
      if (
        x.attributes.find(
          z => z.key == terytName && z.val.length == sortedLength[2]
        )
      ) {
        vivoideshipRouteCategory.push(x);
      }
      if (
        x.attributes.find(
          z => z.key == terytName && z.val.length == sortedLength[3]
        )
      ) {
        countryRouteCategory.push(x);
      }
    });

    var terytSortedFeatures = [
      communeRouteCategory,
      districtRouteCategory,
      vivoideshipRouteCategory,
      countryRouteCategory
    ];

    terytSortedFeatures.forEach(item => {
      sortedCategories.forEach(sortedCat => {
        item.forEach(x => {
          if (
            x.attributes.find(
              z => z.key == categoryName && z.val.includes(sortedCat)
            )
          )
            sortedFeaturesData.push(x);
        });
      });
    });

    state.featuresData = sortedFeaturesData;
  },
  [SELECT_CONTROL_SET](state, control) {
    state.control = control;
  },
  [SELECT_MODE_SET](state, mode) {
    if (mode === state.mode) {
      state.mode = MODE_NONE;
    } else {
      state.mode = mode;
    }
  },
  [SELECT_DRAWN_FEATURE_SET](state, selectModeDrawnedFeature) {
    state.selectModeDrawnedFeature = selectModeDrawnedFeature;
  },
  setDrawLayer(state, drawLayer) {
    state.drawLayer = drawLayer;
  },
  setDrawInteraction(state, drawInteraction) {
    state.drawInteraction = drawInteraction;
  },
  setClearSelectedFeatures(state) {
    state.selectedFeatures = new Set();
  },
  applySelectionForLayer(state, selectedIds) {
    state.selectedFeatures = new Set(selectedIds);
  },
  applySelectionObjectsForLayer(state, selectedObjects) {
    state.selectedObjects = selectedObjects;
  },
  [SELECT_MULTIPLE_ACTIVATE](state, active) {
    state.pointModeMultiple = active;
  },
  toggleGettingFeatureInfo(state) {
    state.gettingFeatureInfo = !state.gettingFeatureInfo;
  }
};

const getters = {
  isMapFeatureSelected: state => (layer, featureId) => {
    if (state.layersWithAllFeaturesSelected.has(layer)) {
      return true;
    }
    return state.selectedFeatures.has(featureId);
  },
  featurePopupPosition: state => {
    return state.featurePopupPosition;
  },
  multipleFeaturePopupPosition: state => state.multipleFeaturePopupPosition,
  featurePopupLayerActive: state => {
    return state.featurePopupLayer ? state.featurePopupLayer.active : false;
  },
  featurePopupAttributes: state => {
    return state.featurePopupAttributes;
  },
  multipleFeaturePopupData: state => {
    return state.featuresData;
  },
  featurePopupHeader: state => {
    return state.featurePopupHeader;
  },
  featuresList: state => {
    return uniqBy(state.featuresList, "id");
  },
  featureDropdownPosition: state => {
    return state.featureDropdownPosition;
  },
  userEmail: state => {
    return state.userEmail;
  },
  userOrgId: state => {
    return state.userOrgId;
  },
  featurePopupHtml: state => state.featurePopupHtml,
  selectModeDrawnedFeature() {
    return state.selectModeDrawnedFeature;
  },
  selectedMapFeatures() {
    return state.selectedFeatures;
  },
  selectedMapObjects() {
    return state.selectedObjects;
  },
  isSelectModePoint() {
    return state.mode === MODE_POINT;
  },
  isSelectModePolygon() {
    return state.mode === MODE_POLYGON;
  },
  isSelectModeRectangle() {
    return state.mode === MODE_RECTANGLE;
  },
  isSelectModeNone() {
    return state.mode === MODE_NONE;
  },
  layersWithAllFeaturesSelected() {
    return state.layersWithAllFeaturesSelected;
  },
  pointModeMultiple() {
    return state.pointModeMultiple;
  },
  drawLayer() {
    return state.drawLayer;
  },
  getFeatureInfoEnabled: state => state.getFeatureInfoEnabled,
  getReportingDemandEnabled: state => state.getReportingDemandEnabled,
  toggleObjectDetailsState: state => state.toggleObjectDetailsState,
  gettingFeatureInfo: state => state.gettingFeatureInfo,
  getFeatureSelectedLayer: state => state.getFeatureInfoLayer,
  selectionDrawInteraction() {
    return state.drawInteraction;
  }
};

const multiDictionaryKeys = [
  'we12_technologia_dostepowa',
  'we13_uslugi_transmisji_danych',
  'we18_typ_interfejsu',
  'pe12_technologia_dostepowa',
  'pe13_mozliwosc_swiadczenia_uslug',
  'sb32_technologia_mimo',
  'zr02_technologia_dostepowa_420mhz',
  'zr05_technologia_dostepowa_700mhz',
  'zr08_technologia_dostepowa_800mhz',
  'zr11_technologia_dostepowa_900mhz',
  'zr14_technologia_dostepowa_1800mhz',
  'zr17_technologia_dostepowa_2100mhz',
  'zr20_technologia_dostepowa_2600mhz',
  'zr23_technologia_dostepowa_3600mhz',
  'zr26_technologia_dostepowa_26000mhz',
  'ua13_medium_instalacji_budynku'
];
export default {
  state,
  actions,
  mutations,
  getters
};

function getFeature(obj) {
  return {
    id: obj.id
      ? obj.id
      : obj.getId
      ? obj.getId()
      : obj.properties
      ? obj.properties.id
      : undefined,
    properties: obj.properties ? obj.properties : obj.getProperties(),
    geometry: obj.geometry,
    flatCoordinates: obj.flatCoordinates,
    selected: true,
    loadedFromMap: true,
    extent: obj.extent
  };
}

function multiDictionary(item, val) {
  if (item.dictionary.length !== 0) {
    let dictionaryVal = '';
    function dec2bin(dec) {
      //convert dec to binary string
      return (dec >>> 0).toString(2);
    }
    const myNumberBin = dec2bin(val);
    for (let i = myNumberBin.length - 1; i >= 0; i--) {
      if (myNumberBin[i] === '1') {
        if (dictionaryVal === '') {
          dictionaryVal = item.dictionary[myNumberBin.length - 1 - i].wartosc;
        } else {
          dictionaryVal =
            dictionaryVal +
            ', ' +
            item.dictionary[myNumberBin.length - 1 - i].wartosc;
        }
      }
    }
    return dictionaryVal;
  }
  return val;
}

function tryGetFeatureAtPixelOnVectorLayer(map, vectorLayer, pixel) {
  let selected = [];
  map.forEachFeatureAtPixel(
    pixel,
    function(x) {
      selected.push(x);
    },
    {
      layerFilter: function(layer) {
        return layer === vectorLayer;
      }
    }
  );
  return selected;
}

function tryGetFeatureAtPixel(map, layers, pixel) {
  var mapLayersDict = {};
  var selectedFeature = null;
  var selectedFeatureLayer = null;
  var maxZIndex = null;
  const layersWithFoundObjects = [];
  const features = [];

  var callback = function(feature, layer) {
    if (layer) {
      let zIndex = layer.getZIndex();

      if (layersWithFoundObjects.indexOf(layer) === -1) {
        layersWithFoundObjects.push(layer);
      }

      if (!maxZIndex || zIndex > maxZIndex) {
        selectedFeatureLayer = mapLayersDict[layer.ol_uid];
        selectedFeature = feature;
        maxZIndex = zIndex;
      }
      features.push(feature);
    }
  };

  map.forEachFeatureAtPixel(pixel, callback, {
    hitTolerance: 15,
    layerFilter: function(layer) {
      var featureLayer = layers.find(
        item => item.visible && item.mapLayer === layer
      );
      if (featureLayer) {
        mapLayersDict[featureLayer.mapLayer.ol_uid] = featureLayer;
        return true;
      }

      const featureHistoricalLayer = layers.find(
        l =>
          !!l.mapHistoricalLayer &&
          l.mapHistoricalLayer.getVisible() &&
          l.mapHistoricalLayer === layer
      );
      if (featureHistoricalLayer) {
        const historicalLayer = featureHistoricalLayer.mapHistoricalLayer;
        mapLayersDict[historicalLayer.ol_uid] = historicalLayer;
        return true;
      }
    }
  });

  let selectedFeatureObj = null;

  if (layersWithFoundObjects.length == 1 && selectedFeature) {
    selectedFeatureObj = {
      id: selectedFeature.properties_
        ? selectedFeature.properties_['element_uuid']
        : undefined,
      properties: selectedFeature.properties_ || [],
      flatCoordinates: selectedFeature.flatCoordinates_ || [],
      extent: selectedFeature.extent_
    };
  }

  const selectedFeatures = features.map(feature => {
    return {
      id: feature.properties_
        ? feature.properties_['element_uuid']
        : undefined,
      properties: feature.properties_ || [],
      flatCoordinates: feature.flatCoordinates_ || [],
      extent: feature.extent_
    }
  })

  return {
    selectedFeature: selectedFeatureObj,
    selectedFeatures: selectedFeatures,
    selectedFeatureLayer: selectedFeatureLayer,
    layersWithFoundObjects: layersWithFoundObjects.length
  };
}

function getFeatureInfoPromise(
  source,
  coordinate,
  resolution,
  coordinateSystem,
  layer
) {
  let url = source.getGetFeatureInfoUrl(
    coordinate,
    resolution,
    coordinateSystem,
    { INFO_FORMAT: 'application/json', FEATURE_COUNT: '50' }
  );

  const api = new ApiUslugiMapowe();

  return new Promise(function(resolve, reject) {
    api
      .getWfsProxy({
        wso2_id: this.contextEmail ? this.contextEmail : null,
        orgid: this.contextOrganizationId ? this.contextOrganizationId : null,
        url: url
      })
      .then(response => resolve({ response, layer }))
      .catch(_ => reject());
  });
}

function getLayerSource(layer, resolution, coordinateSystem) {
  let source = null;
  let hasHighResolutionVersion = !!layer.mapHighResolutionLayer;
  let highResolutionVersionUsed =
    hasHighResolutionVersion &&
    resolution >= layer.mapHighResolutionLayer.getMinResolution();
  if (highResolutionVersionUsed) {
    source = layer.mapHighResolutionLayer.getSource();
  } else if (layer.mapLayer.getVisible()) {
    source = layer.mapLayer.getSource();
  } else if (
    layer.mapHistoricalLayer &&
    layer.mapHistoricalLayer.getVisible()
  ) {
    source = layer.mapHistoricalLayer.getSource();
  }

  if (
    layer.isSystem &&
    (!source || !source.getGetFeatureInfoUrl) &&
    layer.datasource &&
    (!hasHighResolutionVersion || highResolutionVersionUsed)
  ) {
    source = new TileWMSSource({
      url: settings.geoserverUrl + '/wms',
      params: {
        LAYERS: 'pit:' + layer.datasource,
        TILED: true,
        VERSION: '1.1.1',
        HEIGHT: 512,
        WIDTH: 512,
        STYLES: layer.styleId
      },
      projection: coordinateSystem
    });
  }

  return source;
}

async function tryGetFeatureAtCoordinateBySource(payload) {
  const promises = [];
  const layers = payload.layers;

  layers.forEach(function(layer) {
    if (
      layer.visible ||
      (layer.mapHistoricalLayer && layer.mapHistoricalLayer.getVisible())
    ) {
      const source = getLayerSource(
        layer,
        payload.resolution,
        payload.coordinateSystem
      );
      if (source && source.getGetFeatureInfoUrl) {
        const promise = getFeatureInfoPromise(
          source,
          payload.coordinate,
          payload.resolution,
          payload.coordinateSystem,
          layer
        );
        promises.push(promise);
      }
    }
  });

  const getFeatureResult = { layers: [], selectionError: false };

  try {
    const results = await Promise.all(promises);
    results.forEach(apiResult => {
      try {
        const result = apiResult.response.body;

        if (
          result &&
          Array.isArray(result.features) &&
          result.features.length >= 1
        ) {
          const layer = { features: [], selectedFeatureLayer: apiResult.layer };
          result.features.forEach(feature => {
            const coordinates = feature.geometry.coordinates;
            const type = feature.geometry
              ? feature.geometry.type.toLowerCase()
              : undefined;
            let geometry = null;

            switch (type) {
              case 'point':
                geometry = new Point(coordinates);
                break;
              case 'polygon':
                geometry = new Polygon(coordinates);
                break;
              case 'linestring':
                geometry = new LineString(coordinates);
                break;
              case 'multipolygon':
                geometry = new MultiPolygon(coordinates);
                break;
            }

            let isStawkiLayer = layer.selectedFeatureLayer.names.includes(
              'pit:drogi_stawki_jst'
            );

            layer.features.push({
              id: !!feature.properties['element_uuid']
                ? feature.properties['element_uuid']
                : feature.id,
              properties: isStawkiLayer
                ? changeFeaturePropertiesNames(feature.properties)
                : feature.properties,
              flatCoordinates: coordinates,
              extent: geometry.getExtent()
            });
          });

          getFeatureResult.layers.push(layer);
        }
      } catch (e) {
        getFeatureResult.selectionError = true;
      }
    });
  } catch (e) {
    getFeatureResult.selectionError = true;
  } finally {
    return getFeatureResult;
  }
}

async function findFeatureForSingleClickSelection(context, payload, layers) {
  context.commit(SELECT_FEATURE_POPUP_HIDE);

  if (!layers) {
    layers = [];

    const activeLayer = context.rootGetters.layers.find(x => x.active);

    if (activeLayer) {
      layers.push(activeLayer);
    } else if (state.getFeatureInfoSelectedLayer) {
      layers.push(state.getFeatureInfoSelectedLayer);
    } else {
      layers.push(
        ...context.rootGetters.layers.filter(
          x =>
            (x.isSystem && rasterLayers.indexOf(x.type) < 0) ||
            (!!x.mapHistoricalLayer && x.mapHistoricalLayer.getVisible()) ||
            (x.names &&
              (x.names.includes('pit:nadlesnictwa') ||
                x.names.includes('pit:rejestr_nieruchomosci') ||
                x.names.includes('pit:drogi_stawki_jst') ||
                x.names.includes('pit:drogi_stawki') ||
                x.names.includes('pit:decyzja')))
        )
      );
    }
  }

  if (context.rootGetters.editSession) {
    const featuresFoundOnEditLayer = tryGetFeatureAtPixelOnVectorLayer(
      payload.map,
      context.rootGetters.editSessionMapLayer,
      payload.event.pixel
    );

    if (featuresFoundOnEditLayer[0]) {
      return {
        selectedFeatures: featuresFoundOnEditLayer,
        onEditSessionMapLayer: true,
        featuresFound: true
      };
    }
  }

  const result = tryGetFeatureAtPixel(payload.map, layers, payload.event.pixel);
  if (result.layersWithFoundObjects > 1) return { manyLayersFound: true };

  let selectedFeature = result.selectedFeature;
  let selectedFeatureLayer = result.selectedFeatureLayer;

  if (selectedFeature) {
    return {
      featuresFound: true,
      selectedFeatures: result.selectedFeatures,
      selectedFeatureLayer: selectedFeatureLayer
    };
  } else {
    const coordinateBySourceAllFeatures = await tryGetFeatureAtCoordinateBySource(
      {
        coordinate: payload.event.coordinate,
        layers: layers,
        resolution: context.rootGetters.resolution,
        coordinateSystem: context.getters.coordinateSystem
      }
    );

    if (coordinateBySourceAllFeatures.selectionError) {
      return { selectionError: true };
    }

    const foundLayers = coordinateBySourceAllFeatures.layers;

    if (foundLayers.length > 1) {
      return { manyLayersFound: true };
    } else if (foundLayers.length == 1) {
      selectedFeature = foundLayers[0].features[0];
      selectedFeatureLayer = foundLayers[0].selectedFeatureLayer;
      if (selectedFeatureLayer && Array.isArray(selectedFeatureLayer.names)) {
        if (selectedFeatureLayer.names.includes('pit:nadlesnictwa')) {
          selectedFeatureLayer.attributes = [
            {
              description: 'Warunki dostępu',
              displayed: true,
              index: 0,
              key: 'www_warunki_dostepu',
              name: 'Warunki dostępu',
              order: 0,
              read_only: true,
              type: 'text',
              visible: true,
              isLink: true
            },
            {
              description: 'Nazwa',
              displayed: true,
              index: 0,
              key: 'nazwa',
              name: 'Nazwa',
              order: 1,
              read_only: true,
              type: 'text',
              visible: false
            },
            {
              description: 'Organ',
              displayed: true,
              index: 0,
              key: 'organ',
              name: 'Organ',
              order: 2,
              read_only: true,
              type: 'text',
              visible: true
            }
          ];
          selectedFeatureLayer.atrybutNazwa = 'nazwa';
          if (!selectedFeature.properties.www_warunki_dostepu) {
            selectedFeatureLayer.attributes[0].isLink = false;
            selectedFeature.properties.www_warunki_dostepu = 'brak danych';
          }

          if (!selectedFeature.properties.organ) {
            selectedFeature.properties.organ = 'brak danych';
          }
        } else if (
          selectedFeatureLayer.names.includes('pit:rejestr_nieruchomosci')
        ) {
          selectedFeatureLayer.attributes = [
            {
              description: 'Warunki dostępu',
              displayed: true,
              index: 0,
              key: 'www_warunki_dostepu',
              name: 'Warunki dostępu',
              order: 0,
              read_only: true,
              type: 'text',
              visible: true,
              isLink: true
            },
            {
              description: 'Adres nieruchomości',
              displayed: true,
              index: 0,
              key: 'adres_nieruchomosci',
              name: 'Adres nieruchomości',
              order: 1,
              read_only: true,
              type: 'text',
              visible: false
            }
          ];
          selectedFeatureLayer.atrybutNazwa = 'adres_nieruchomosci';
          if (!selectedFeature.properties.adres_nieruchomosci) {
            selectedFeature.properties.adres_nieruchomosci = 'brak danych';
          }

          if (!selectedFeature.properties.www_warunki_dostepu) {
            selectedFeatureLayer.attributes[0].isLink = false;
            selectedFeature.properties.www_warunki_dostepu = 'brak danych';
          }
        } else if (selectedFeatureLayer.names.includes('pit:drogi_stawki')) {
          selectedFeatureLayer.attributes = [];
          const propsToExclude = ['id_drogi', 'numer', 'id'];
          for (let prop in selectedFeature.properties) {
            if (propsToExclude.indexOf(prop) !== -1) continue;

            selectedFeatureLayer.attributes.push({
              description: prop,
              displayed: true,
              index: selectedFeatureLayer.attributes.length,
              key: prop,
              name: prop,
              order: 0,
              read_only: true,
              type: 'text',
              visible: true
            });
          }
        } else if (
          selectedFeatureLayer.names.includes('pit:drogi_stawki_jst')
        ) {
          selectedFeatureLayer.attributes = [];
          for (let prop in selectedFeature.properties) {
            selectedFeatureLayer.attributes.push({
              description: prop,
              displayed: true,
              index: selectedFeatureLayer.attributes.length,
              key: prop,
              name: prop,
              order: 0,
              read_only: true,
              type: 'text',
              visible: true,
              isLink: prop == 'link_uchwaly'
            });
          }
        } else if (selectedFeatureLayer.names.includes('pit:decyzja')) {
          selectedFeatureLayer.attributes = [];
          let toIgnore = ['created_at', 'updated_at', 'organizacja'];
          for (let prop in selectedFeature.properties) {
            if (!toIgnore.includes(prop)) {
              selectedFeatureLayer.attributes.push({
                description: prop,
                displayed: true,
                index: selectedFeatureLayer.attributes.length,
                key: prop,
                name: prop,
                order: 0,
                read_only: true,
                type: 'text',
                visible: true
              });
            }
          }
        }
      }

      const isStawkiJst = selectedFeatureLayer.names.includes(
        'pit:drogi_stawki_jst'
      );

      return {
        featuresFound: true,
        selectedFeatures: isStawkiJst
          ? foundLayers[0].features
          : [foundLayers[0].features[0]],
        selectedFeatureLayer: selectedFeatureLayer
      };
    }

    return { featuresFound: false };
  }
}
